import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styled from "styled-components";
import image from "../images/doctor-with-co-workers-analyzing-x-ray.jpg";

const ImageWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
  height: calc(70vh - 80px);
  margin-bottom: 0px;
  overflow-y: hidden;
  position: relative;

  @media (max-width: 900px) {
    height: calc(40vh - 60px);
  }
`;

const Image = styled.img`
  width: 100%;
  height: 80vh;
  object-fit: cover;
  @media (max-width: 900px) {
    height: 45vh;
  }
`;

const ImageCarousel = ({ setLimit }) => {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const divRef = useRef(0);

  useEffect(() => {
    setLimit(divRef.current.offsetHeight);
  }, [windowHeight]);

  useEffect(() => {
    function handleResize() {
      setWindowHeight(window.innerHeight);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <ImageWrapper ref={divRef}>
      <Image src={image} alt={"imagem medicos"} />
    </ImageWrapper>
  );
};

export default ImageCarousel;
